import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const resetIcon = createIconDefinition(
  'reset',
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 3.33333C10.5773 3.33333 12.6667 5.42267 12.6667 8C12.6667 10.5773 10.5773 12.6667 8 12.6667C6.27352 12.6667 4.76514 11.7295 3.95723 10.3328L3.62341 9.75578L2.46927 10.4234L2.80309 11.0005C3.83953 12.7922 5.77832 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C6.11445 2 4.43288 2.86972 3.33333 4.22865V2.53333H2V5.54667C2 6.09157 2.44171 6.53333 2.98667 6.53333H3.09516C3.10514 6.53356 3.11511 6.53356 3.12506 6.53333H6V5.2H4.26617C5.11801 4.06592 6.47394 3.33333 8 3.33333Z" fill="#5A42D0"/>
</svg>
`,
);
